export default async ({ route, store }) => {
  const jumbotronParams = { amount: store.getters['utils/getEnergySavings'] };
  const jumbo = {...store.getters['pageContent/getJumbotron']};
  delete jumbo['params'];
  jumbo['params'] = jumbotronParams;
  store.commit('pageContent/setJumbotron', jumbo);
};
